var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BaseTableFiltered', {
    staticClass: "mt-3",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.courseList,
      "search": _vm.search,
      "loading": _vm.loading,
      "loading-text": "Henter kurs",
      "sort-by": "id",
      "group-by": _vm.currentGroupBy || null
    },
    scopedSlots: _vm._u([{
      key: "groupHeader",
      fn: function fn(_ref) {
        var group = _ref.group;
        return [_vm._v(" " + _vm._s(_vm.formatGroupBy(group)) + " ")];
      }
    }, {
      key: "actions",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref3) {
              var on = _ref3.on,
                  attrs = _ref3.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "data-cy": "openCourse-".concat(item.id)
                },
                on: {
                  "click": function click($event) {
                    return _vm.navigateToCoursePage(item.id);
                  }
                }
              }, 'v-icon', attrs, false), on), [_vm._v(" mdi-open-in-new ")])];
            }
          }], null, true)
        }, [_c('span', [_vm._v("Åpne kurs")])]), !_vm.hasMemberOrgAccess ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref4) {
              var on = _ref4.on,
                  attrs = _ref4.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "data-cy": "editCourse-".concat(item.id)
                },
                on: {
                  "click": function click($event) {
                    return _vm.navigateToEditCourse(item.id);
                  }
                }
              }, 'v-icon', attrs, false), on), [_vm._v(" mdi-pencil ")])];
            }
          }], null, true)
        }, [_c('span', [_vm._v("Rediger kurs")])]) : _vm._e()];
      }
    }, {
      key: "item.startDate",
      fn: function fn(_ref5) {
        var value = _ref5.value;
        return [_vm._v(" " + _vm._s(value ? _vm.formatDateShort(value) : "") + " ")];
      }
    }, {
      key: "item.endDate",
      fn: function fn(_ref6) {
        var value = _ref6.value;
        return [_vm._v(" " + _vm._s(value ? _vm.formatDateShort(value) : "") + " ")];
      }
    }, {
      key: "item.enrollmentDeadline",
      fn: function fn(_ref7) {
        var value = _ref7.value;
        return [_vm._v(" " + _vm._s(value ? _vm.formatDateShort(value) : "") + " ")];
      }
    }], null, true)
  });
}
var staticRenderFns = []

export { render, staticRenderFns }